var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    { attrs: { tag: "w-container" } },
    [
      _c("div", { staticClass: "sticky-top" }, [
        _vm._v(
          " " + _vm._s(_vm.userName) + " " + _vm._s(_vm.companyName) + " "
        ),
      ]),
      !_vm.item
        ? _c(
            "w-row",
            { staticClass: "grow", attrs: { center: "" } },
            [
              _c(
                "w-col",
                { staticClass: "grow", attrs: { xs: "12", center: "" } },
                [_c("w-progress-circular")],
                1
              ),
            ],
            1
          )
        : _c(
            "w-row",
            { style: { height: "100%" } },
            [
              _c(
                "w-col",
                { attrs: { sm: "12", md: "12", lg: "12", center: "" } },
                [
                  _c(
                    "w-card",
                    { attrs: { "max-width": "600" } },
                    [
                      _c("w-card-title", [
                        _vm._v(" " + _vm._s(_vm.$ct("title")) + " "),
                      ]),
                      _c(
                        "w-card-content",
                        [
                          !_vm.item.FromSelection
                            ? _c(
                                "w-col",
                                {
                                  staticClass: "mb",
                                  attrs: { xs: "12", md: "6" },
                                },
                                [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.$ct("period"))),
                                  ]),
                                  _c("div", { staticClass: "info" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$ct("from")) +
                                        " " +
                                        _vm._s(_vm.beginDate) +
                                        " " +
                                        _vm._s(_vm.$ct("till")) +
                                        " " +
                                        _vm._s(_vm.endDate) +
                                        " "
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _c("w-col", { attrs: { xs: "12" } }, [
                            _c("label", [_vm._v(_vm._s(_vm.$ct("message")))]),
                            _c("div", { staticClass: "info" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.item.Message
                                      ? _vm.item.Message
                                      : _vm.$ct("no-message")
                                  ) +
                                  " "
                              ),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "w-card-actions",
                        [
                          _c(
                            "w-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.download()
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.$ct("button")) + " ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "created-box" }, [
                    _c("div", { staticClass: "created" }, [
                      _c("img", {
                        attrs: { src: "/img/icons/128.png", width: "32" },
                      }),
                      _vm._v(" Created by Winfakt "),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }